import PropTypes from 'prop-types'
import React from 'react'

import Icon from 'components/Icon'
import SectionWrapper from 'components/SectionWrapper'
import { Text, H1Small as H1 } from 'styles/components/typography'

import {
  Cover,
  Content,
  IconWrapper,
  FrameWrapper,
  FrameMacStraightStyled,
  HeaderWrapper,
} from './styles'

const IMAGE = 'dashboard'

const WResultsInvestment = ({ data, pathCdn }) => (
  <SectionWrapper
    isOverflowHidden={true}
    beforeElement={<Cover isTablet={true} />}
  >
    <div className="row">
      <div className="col-12 col-md-8">
        <Cover />
        <FrameWrapper className="py-md-4">
          <div className="position-relative py-4 py-md-0">
            <HeaderWrapper>
              <H1 as="h2" dangerouslySetInnerHTML={{ __html: data.title }} />
            </HeaderWrapper>
            <FrameMacStraightStyled
              className="d-results-health__frame"
              src={`${pathCdn}/${IMAGE}`}
              alt={IMAGE}
            >
              <IconWrapper className="hh-thin">
                <Icon id="color_hh-thin" />
              </IconWrapper>
            </FrameMacStraightStyled>
          </div>
        </FrameWrapper>
      </div>
      <div className="col-12 py-4 order-md-0 col-md-4">
        <Content>
          <Content>
            <Text dangerouslySetInnerHTML={{ __html: data.content }} />
          </Content>
        </Content>
      </div>
    </div>
  </SectionWrapper>
)

WResultsInvestment.propTypes = {
  data: PropTypes.object.isRequired,
  pathCdn: PropTypes.string.isRequired,
}

export default WResultsInvestment
